export default function attachments(context, content) {
  context.attachmentData = context.attachmentData || [];
  // Making user friendly attachments data
  content.$$?.forEach((attachment) => {
    const attachmentProps = {};
    attachment.$$.forEach((prop) => {
      attachmentProps[prop['#name']] = prop._;
    });
    context.attachmentData.push(attachmentProps);
  });
}
